import { render, staticRenderFns } from "./quick-radio.vue?vue&type=template&id=2d1e284a&scoped=true&"
import script from "./quick-radio.vue?vue&type=script&lang=js&"
export * from "./quick-radio.vue?vue&type=script&lang=js&"
import style0 from "./quick-radio.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./quick-radio.vue?vue&type=style&index=1&id=2d1e284a&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2d1e284a",
  null
  
)

export default component.exports